import { useRouter } from 'next/router';
import EfSpec from 'elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useMemo } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function PageComp() {
    const { Link } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rule');

    const bpsUrl = useMemo(() => {
        const bps_cn = 'https://websiteoss.ecoflow.com/upload/pdf/1727403710032/bps-cn.pdf';
        const bps_en = 'https://websiteoss.ecoflow.com/upload/pdf/1727403743718/bps-en.pdf';
        switch (locale) {
            case 'cn':
                return bps_cn;
            default:
                return bps_en;
        }
    }, [locale]);

    return (
        <div className={`${css['page-comp']}`}>
            <p className="D-title">{t('D_title')}</p>
            <p className="D-desc">{t('D_desc')}</p>
            <ul className="D-list">
                <li className="D-list-item">
                    <EfImg className="D-list-item-img" pc="https://websiteoss.ecoflow.com/upload/image/1727403873179/bps-icon.jpg" />
                    <p className="D-list-item-title">{t('D_list_title1')}</p>
                    {/* <Link className="D-list-item-link" href={bpsUrl} target="_blank">
                        <span>{t('D_LearnMore')}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            style={{ scale: locale === 'sa' ? '-1' : '1' }}
                        >
                            <path
                                d="M5.99988 3.10645L10.9999 8.10645L5.99988 13.1064"
                                stroke="#3F68E0"
                                strokeWidth="1.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link> */}
                </li>
            </ul>
            <EfSpec />
        </div>
    );
}
